import { env } from "@/env";

export const transcriptionMediaFiles = {
  video: "standard.mp4",
  audio: "audio.m4a",
  vocals: "vocals.wav",
  other: "other.wav",
} as const;

export const getTranscriptionMediaDownloadUrl = ({
  jobId,
  media,
  fileName,
}: {
  jobId: string;
  media: keyof typeof transcriptionMediaFiles;
  fileName: string;
}) => `/api/v1/download-media?${new URLSearchParams({ jobId, media, fileName })}`;

export const getPublicBucketBaseUrl = () => {
  if (env.NEXT_PUBLIC_RESULT_BUCKET_R2) {
    return env.NEXT_PUBLIC_RESULT_BUCKET_R2;
  } else {
    return `https://${env.NEXT_PUBLIC_RESULT_BUCKET_NAME}.s3.eu-central-1.amazonaws.com`;
  }
};

export const getTranscriptionAudioUrl = ({ jobId }: { jobId: string }) => {
  const path = `/transcription_jobs/${jobId}/audio.m4a`;
  const url = `${getPublicBucketBaseUrl()}${path}`;
  return url;
};

export const getTranscriptionVocalsUrl = ({ jobId }: { jobId: string }) => {
  const path = `/transcription_jobs/${jobId}/vocals.wav`;
  const url = `${getPublicBucketBaseUrl()}${path}`;
  return url;
};

export const getTranscriptionOtherUrl = ({ jobId }: { jobId: string }) => {
  const path = `/transcription_jobs/${jobId}/other.wav`;
  const url = `${getPublicBucketBaseUrl()}${path}`;
  return url;
};

export const getTranscriptionVideoUrl = ({ jobId }: { jobId: string }) => {
  const path = `/transcription_jobs/${jobId}/standard.mp4`;
  const url = `${getPublicBucketBaseUrl()}${path}`;
  return url;
};
